import React, { StrictMode } from "react";
import App from "./App";
import "./style/app.scss"
import  ReactDOM  from "react-dom";
import "./style/app.scss"
const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);


root.render(
  <StrictMode>
 
  <App />
 
    
  </StrictMode>
);

